import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { RollObjectEditor } from "../objectEditors";
import { ObjectAlert } from "../alerts";

export class RollObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: ObjectAlert[] = [];
    if (object instanceof RollObjectEditor) {
      const options = object.rollSelectBehavior().getValue().options;
      if (!options || options.length < 1) {
        alerts.push(new ObjectAlert(object, "クリック選択項目を追加してください。"));
      }
    }
    return alerts;
  }
}
